import { useEffect, useRef, useState } from 'react';
import { searchUsers } from '../api/users';

export default function AutocompleteUser({ value, onSelect, placeholder='Покупатель' }) {
  const [q, setQ] = useState(value || '');
  const [opts, setOpts] = useState([]);
  const [open, setOpen] = useState(false);
  const [hi, setHi] = useState(-1);
  const boxRef = useRef(null);
  const tRef = useRef(null);

  useEffect(() => {
    if (!q || q.trim().length < 2) { setOpts([]); return; }
    clearTimeout(tRef.current);
    tRef.current = setTimeout(async () => {
      const rows = await searchUsers(q.trim());
      setOpts(rows);
      setOpen(true);
      setHi(-1);
    }, 200);
    return () => clearTimeout(tRef.current);
  }, [q]);

  useEffect(() => {
    const onDoc = (e) => { if (boxRef.current && !boxRef.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', onDoc);
    return () => document.removeEventListener('mousedown', onDoc);
  }, []);

  function choose(u) {
    const label = `${u.name || ''}${u.phone ? ' · '+u.phone : ''}${u.email ? ' · '+u.email : ''}`.trim();
    setQ(label);
    setOpen(false);
    onSelect?.(u);
  }

  function onKey(e) {
    if (!open || !opts.length) return;
    if (e.key === 'ArrowDown') { e.preventDefault(); setHi(i => Math.min(i+1, opts.length-1)); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); setHi(i => Math.max(i-1, 0)); }
    else if (e.key === 'Enter') { e.preventDefault(); if (hi >= 0) choose(opts[hi]); }
    else if (e.key === 'Escape') { setOpen(false); }
  }

  return (
    <div className="ac-user" ref={boxRef}>
      <input
        className="fld"
        placeholder={placeholder}
        value={q}
        onChange={e=>setQ(e.target.value)}
        onFocus={()=>opts.length && setOpen(true)}
        onKeyDown={onKey}
        autoComplete="off"
      />
      {open && opts.length > 0 && (
        <div className="ac-user__list">
          {opts.map((u, i) => (
            <div
              key={u._id}
              className={`ac-user__opt ${i===hi ? 'is-hi':''}`}
              onMouseEnter={()=>setHi(i)}
              onMouseDown={(e)=>{ e.preventDefault(); choose(u); }}
            >
              <div className="ac-user__name">{u.name || 'Без имени'}</div>
              <div className="ac-user__meta">
                {u.phone || '—'} {u.email ? `· ${u.email}` : ''} {u.role ? `· ${u.role}` : ''}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
